import { createIcon } from '../utils';

export const ArchiveIconPatientTimeline = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.33341 6.66667H16.6667V13.5C16.6667 14.9001 16.6667 15.6002 16.3943 16.135C16.1546 16.6054 15.7721 16.9878 15.3017 17.2275C14.7669 17.5 14.0669 17.5 12.6667 17.5H7.33341C5.93328 17.5 5.23322 17.5 4.69844 17.2275C4.22803 16.9878 3.84558 16.6054 3.6059 16.135C3.33341 15.6002 3.33341 14.9001 3.33341 13.5V6.66667Z"
        fill="currentColor"
        fillOpacity={0.16}
      />
      <path
        d="M3.33341 6.66383C3.19674 6.6603 3.09749 6.65239 3.00826 6.63464C2.34711 6.50313 1.83028 5.9863 1.69877 5.32515C1.66675 5.16415 1.66675 4.97055 1.66675 4.58333C1.66675 4.19612 1.66675 4.00251 1.69877 3.84152C1.83028 3.18037 2.34711 2.66354 3.00826 2.53202C3.16926 2.5 3.36287 2.5 3.75008 2.5H16.2501C16.6373 2.5 16.8309 2.5 16.9919 2.53202C17.653 2.66354 18.1699 3.18037 18.3014 3.84152C18.3334 4.00251 18.3334 4.19612 18.3334 4.58333C18.3334 4.97055 18.3334 5.16415 18.3014 5.32515C18.1699 5.9863 17.653 6.50313 16.9919 6.63464C16.9027 6.65239 16.8034 6.6603 16.6667 6.66383M8.33341 10.8333H11.6667M3.33341 6.66667H16.6667V13.5C16.6667 14.9001 16.6667 15.6002 16.3943 16.135C16.1546 16.6054 15.7721 16.9878 15.3017 17.2275C14.7669 17.5 14.0669 17.5 12.6667 17.5H7.33341C5.93328 17.5 5.23322 17.5 4.69844 17.2275C4.22803 16.9878 3.84558 16.6054 3.6059 16.135C3.33341 15.6002 3.33341 14.9001 3.33341 13.5V6.66667Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'ArchiveIconPatientTimeline' },
);
